<template>
    <v-card min-width="100%"
            color="grey darken-3"
            :elevation="elevation"
            class="question-box d-flex flex-row">

        <v-card-text class="drag-handle pb-2" @mousedown="increaseElevation" @mouseup="restoreElevation">
            <v-icon :color="dragHandleColor">{{ dragHandleIcon }}</v-icon>
        </v-card-text>

        <v-card-text class="d-flex">
            <v-tooltip top color="primary" max-width="500" open-delay="200" v-if="missingLocales.length > 0">
                <template v-slot:activator="{ on }">
                    <div class="d-flex align-self-center" v-on="on">
                        <v-btn class="align-self-center ml-4" icon small color="warning">
                            <v-icon left>mdi-alert</v-icon>
                        </v-btn>
                    </div>
                </template>
                This question is missing localization for the following
                required sub panel locale(s) {{ missingLocales.join(', ') }}. This means that
                the registration will not be available for this locale! Add localizations for
                this data variable by clicking on the EDIT -button on your right.
            </v-tooltip>
            <div class="align-self-center">
                {{ name ? name : variable.name }}
            </div>
        </v-card-text>

        <v-spacer></v-spacer>

        <v-card-text class="text-right pa-2" v-if="editable">

            <div class="d-flex justify-end">

                <div class="align-self-center mr-5">
                    <v-tooltip top color="primary" open-delay="200">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="green" v-if="required">mdi-check-bold</v-icon>
                            <v-icon v-on="on" color="grey" v-else>mdi-share-all</v-icon>
                        </template>
                        <span v-if="required">This question is required</span>
                        <span v-else>This question can be skipped</span>
                    </v-tooltip>
                </div>

                <v-btn color="primary" small class="align-self-center" @click="editClicked">EDIT</v-btn>

                <v-tooltip top color="primary" open-delay="200">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" :disabled="!canBeDeleted" class="align-self-center">
                            <v-icon @click="deleteItem" color="grey lighten-1">
                                {{ canBeDeleted ? 'mdi-delete' : 'mdi-empty' }}
                            </v-icon>
                        </v-btn>
                    </template>
                    Delete question
                </v-tooltip>

            </div>
        </v-card-text>

        <edit-variable-dialog
            v-if="variable"
            v-model="editDialogModel"
            :variable="variable"
            :locales="locales"
        ></edit-variable-dialog>
    </v-card>
</template>

<script>

import {mapState} from 'vuex';
import Json from 'vue-json-pretty';
import EditVariableDialog from "./EditVariableDialog";

export default {

    name: "QuestionBox",

    components: {
        Json,
        EditVariableDialog
    },

    props: {

        variable: {
            type: Object,
            required: false,
            default: null,
        },

        name: {
            type: String,
            required: false,
            default: null,
        },

        locales: {
            type: Array,
            required: false,
            default: null,
        },

        requiredLocales: {
            type: Array,
            required: false,
            default: null,
        },

        disableDragHandle: {
            type: Boolean,
            required: false,
            default: false,
        },

        canBeDeleted: {
            type: Boolean,
            required: false,
            default: true
        },

        dragHandleIcon: {
            type: String,
            required: false,
            default: 'mdi-drag'
        },

        dragHandleColor: {
            type: String,
            required: false,
            default: 'grey lighten-2'
        },

        editable: {
            type: Boolean,
            required: false,
            default: false,
        },

        required: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            elevation: 2,
            editDialogModel: false,
        }
    },

    computed: {

        ...mapState('PanelSettings', ['settings']),

        missingLocales() {

            if (!this.locales || !this.requiredLocales) return [];

            return this.requiredLocales
                .filter(locale => {
                    return !this.locales.find(l => l.locale_id === locale.id);
                })
                .map(locale => locale.code);
        }
    },

    methods: {

        editClicked() {
            this.editDialogModel = true;
        },

        deleteItem() {
            this.$emit('delete', this.variable.id);
        },

        increaseElevation() {
            this.elevation = 10;
        },

        restoreElevation() {
            this.elevation = 2;
        }
    }
}
</script>

<style scoped>

.question-box {
    width: 100%;
    height: 50px;
}

.drag-handle {
    width: 70px;
    cursor: pointer;
}

</style>